<div class="modal-header">
    <h4 class="modal-title">Send Quote</h4>
    <button
        sfButton
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    @if (emailTemplate) {
        <form [formGroup]="form">
            <div class="row">
                <div class="col-md-3">
                    <sf-switch
                        description="Include your T & C document (see settings) as an attachment with the quote"
                        label="Include Terms"
                        inputId="includeTerms"
                        formControlName="includeTerms"></sf-switch>
                    <sf-switch
                        description="Send an SMS to the customer explaining they will receive a quote via email"
                        label="Send SMS"
                        inputId="sendSMS"
                        formControlName="sendSMS"></sf-switch>
                    <sf-switch
                        description="Adds a task to the customer profile to remind you in 3 days to chase"
                        label="Setup Chaser"
                        inputId="setupChaser"
                        formControlName="setupChaser"></sf-switch>
                </div>
                <div class="col-md-9">
                    <sf-input label="Email" inputId="email" formControlName="emailAddress"></sf-input>
                    <sf-input label="Subject" inputId="Subject" formControlName="subject"></sf-input>
                    <sf-label for="body" label="Body"></sf-label>
                    <editor id="body" [init]="tinymceSettings" formControlName="body"> </editor>
                </div>
            </div>
        </form>
    }
</div>
<div class="modal-footer">
    <button sfButton type="button" color="dark" (click)="activeModal.close('Close click')">Close</button>
    <button sfButton type="button" color="success" (click)="sendToCustomer()">Send</button>
</div>
